import { Component, Input } from "@angular/core";
import { Subscription } from "rxjs";

import { Config } from "src/app/config";
import { ExamService } from "src/app/services/exam.service";
import { ServerResourcesPathPipe } from "src/app/pipe/serverresourcespath.pipe";
import { PageObjectImage } from "src/app/models/pageobjectimage";
import { Exam } from "src/app/models/exam";

@Component({
  selector: "hkt-pageobjectimage",
  templateUrl: "./pageobjectimage.component.html",
  styleUrls: ["./pageobjectimage.component.scss"],
})
export class PageObjectImageComponent {
  @Input("obj") obj: PageObjectImage;
  @Input("mode") mode: string;

  exam: Exam;
  examSubscription: Subscription;

  constructor(private examService: ExamService, private serverResourcesPathPipe: ServerResourcesPathPipe) {}

  ngOnInit(): void {
    this.exam = this.examService.currentExam;
    this.examSubscription = this.examService.onCurrentExamChange.subscribe(exam => (this.exam = exam));
  }

  ngOnDestroy(): void {
    this.examSubscription.unsubscribe();
  }

  getSourceUrl(): string {
    let image = this.exam.library.getImage(this.obj.image);
    let ret = "";
    if (image == null) {
      ret = "url('assets/notimage.png')";
    } else {
      ret = this.serverResourcesPathPipe.transform(image.source, Config.SERVER_UPLOADFOLDER, "background_url");
    }

    return ret;
  }
}
